import permissionUtil from "mam-common-utils/dist/modules/permissionUtil";

if (!(window as any).nxt) {
    (window as any).nxt = {};
}
(window as any).nxt.permission = (window as any).nxt.permission || {};
(window as any).nxt.permission.judge = permissionUtil.judge;

export let nxt = (window as any).nxt;